// @flow
import React from "react";
import {connect} from "react-redux";
import RideAcceptedTop from "./RideAcceptedTop/RideAcceptedTop";
import RideAcceptedBottom from "./RideAcceptedBottom/RideAcceptedBottom";
import CurrentRideSelectors from "../../../../Store/Ducks/CurrentRide/selectors";
import {bindActionCreators} from "redux";
import BackendOperations from "../../../../Store/Middleware/Backend/operations";


type ConnectedProps = {
    driverName: string,
    vehicleIdentifier: string,
    vehiclePlate: string,
    pickupAddress: string,
    onCallDriver: () => void,
};

const RideAccepted = (props: ConnectedProps) => {
    return ([
        <RideAcceptedTop key="ride_accepted_top"
                         pickupAddress={props.pickupAddress}
        />,
        <RideAcceptedBottom key="ride_accepted_bottom"
                            driverName={props.driverName}
                            vehicleIdentifier={props.vehicleIdentifier}
                            vehiclePlate={props.vehiclePlate}
                            onCallDriver={props.onCallDriver}
        />
    ]);

};

const mapStateToProps = (state, props) => {
    return {
        driverName: CurrentRideSelectors.getDriverName(state),
        vehicleIdentifier: CurrentRideSelectors.getVehicleIdentifier(state),
        vehiclePlate: CurrentRideSelectors.getVehiclePlate(state),
        pickupAddress: CurrentRideSelectors.getPickupAddress(state),
    };
};
const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            onCallDriver: BackendOperations.doGetDriverPhone,
        },
        dispatch);
};
export default connect(mapStateToProps, mapActionsToProps)(RideAccepted);



// WEBPACK FOOTER //
// ./src/Components/Screen/Ride/RideAccepted/RideAccepted.js